import { SCHEDULE_TYPES } from "../../../constants/horario.types"
import * as http from '../../../api/http'
import { ENDPOINTS } from "../../../api/config"
import { GestionUsuarioAction } from "../../../interfaces/gestion-usuarios.interace"
import { Dispatch } from "redux"
import { State } from "../../../reducers"
import { generalOpenToastError, generalOpenToastSuccess, generalShowLoader } from "../../general.actions"
import { FormErrorsHorario, FormHorario } from "../../../interfaces/horario.interfaces"
import { updateUserLocalData } from "../../userLogin.actions"

//REDUX
export const setDataEmpresa = (data: any) => ({type: SCHEDULE_TYPES.SDL_SET_DATA_EMPRESA, payload: data})
export const setDataSucursal = (data: any) => ({type: SCHEDULE_TYPES.SDL_SET_DATA_SUCURSALES, payload: data})
export const setSelectedSucursal = (data: any) => ({type: SCHEDULE_TYPES.SDL_SET_SUCURSAL_SELECTED, payload: data})
export const setFormHorario = (data: any) => ({type: SCHEDULE_TYPES.SDL_SET_FORM_HORARIO, payload: data})
export const setErrorsFormHorario = (data: any) => ({type: SCHEDULE_TYPES.SDL_SET_ERRORS_FORM_HORARIO, payload: data})

//HTTP REQUEST
export const apiGetEmpresaHorario = (params: any) => http.get(ENDPOINTS.GET_HORARIO_EMPRESA, params);
export const apiUpdateHorario = (body: any) => http.post(ENDPOINTS.UPDATE_HORARIO_SUCURSAL, body);

export const gu_hs_getHorariosEmpresa =
  () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
    dispatch(generalShowLoader(true))

    const {datos} = getState().userLogin;
    await http
    .get(ENDPOINTS.GET_HORARIO_EMPRESA, {codigoempresa: datos.codigo_empresa})
    .then(async (res: any) => {
      if (res.status === 200) {
        dispatch(setDataEmpresa(res.data));
        dispatch(setDataSucursal(res.data?.Sucursals));
        dispatch(setSelectedSucursal(null));
      }
    })
    .catch(async (err: any) => {
      dispatch(generalOpenToastError('Datos de horarios no cargados'))
    })
    .finally(() => dispatch(generalShowLoader(false)))
  }

export const gu_hs_onSelectSucursal = (data: any) => async (dispatch: Dispatch<GestionUsuarioAction>) => {
  dispatch(setSelectedSucursal(data));
  const horario = data?.SucursalHorarios[0] ?? null;
  if (horario) {
    dispatch(setFormHorario({
      sinHorario: !horario?.hora_inicio && !horario?.hora_final,
      horaFin: horario?.hora_final ?? '',
      horaInicio: horario?.hora_inicio ?? '',
    }));
  } else {
    dispatch(setFormHorario({sinHorario: true, horaInicio: '', horaFin: ''}));
  }
  setTimeout(() => {
    window.scrollTo({top: document.documentElement.scrollHeight, behavior: 'smooth'});
  }, 100)
}


export const gu_hs_handleChangeFormHorario = (field: keyof FormHorario, value: any) => async (dispatch: Dispatch<GestionUsuarioAction>) => {
  if (field === 'sinHorario') {
    dispatch(setFormHorario({
      sinHorario: value,
      horaFin: '',
      horaInicio: '',
    }))
  } else {
    dispatch(setFormHorario({
      [field]: value
    }))
  }
}

export const gu_hs_handleErrorsFormHorario = () => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
  let errors: FormErrorsHorario = {sinHorario: '', horaFin: '', horaInicio: ''};
  const {formHorario} = getState().horarios;

  for(const field in formHorario){
    const key = field as keyof FormHorario;
    let value = formHorario[key] 

    switch(field){
      case 'sinHorario':
        if (value) errors = {sinHorario: '', horaFin: '', horaInicio: ''};
        break;
      case 'horaInicio':
        if (!formHorario.sinHorario) {
          if(!value) errors.horaInicio = 'Hora de inicio es requerida';
          else if(value == formHorario.horaFin) errors.horaInicio = 'El horario de inicio y salida tienen que ser diferentes';
        }
        break;
      case 'horaFin':
        if (!formHorario.sinHorario) {
          if(!value) errors.horaFin = 'Hora de salida es requerida';
          else if(value == formHorario.horaInicio) errors.horaInicio = 'El horario de inicio y salida tienen que ser diferentes';
        }
        break;
    }
  }

  dispatch(setErrorsFormHorario(errors));
}

export const gu_hs_onClickSaveHorario = (data: any) => async (dispatch: Dispatch<GestionUsuarioAction>, getState: () => State) => {
  const {formHorario, selectedSucursal, dataSucursales} = getState().horarios;
  const {datos} = getState().userLogin;

  try {
    if (selectedSucursal) {
      dispatch(generalShowLoader(true))

      const horario = selectedSucursal.SucursalHorarios[0];
      var body = {
        idsucursal: selectedSucursal.idsucursal,
        idhorariosucursal: horario?.idsucursalhorario ?? null,
        hora_inicio: formHorario.horaInicio, 
        hora_final: formHorario.horaFin,
      }

      const response:any = await apiUpdateHorario(body);
      if (response.status === 200) {
        dispatch(setDataSucursal(dataSucursales.map((sucuItem) => {
          if (sucuItem.idsucursal === selectedSucursal.idsucursal) {
            const horario = sucuItem.SucursalHorarios[0];
            const newHorario = {
              idsucursal: sucuItem.idsucursal, 
              idsucursalhorario: horario ? horario?.idsucursalhorario : response.data,
              hora_inicio: formHorario.horaInicio,
              hora_final: formHorario.horaFin,
            };
            return {...sucuItem, SucursalHorarios: [{...newHorario}]}
          }
          return sucuItem;
        })))

        // Si el usuario cambia la suya que se le actualize en la sesion
        if (datos.sucursal_seleccionada === selectedSucursal.idsucursal) {
          dispatch(updateUserLocalData({
            ...datos, 
            sucursal_hora_inicio: formHorario.horaInicio, 
            sucursal_hora_final: formHorario.horaFin
          }))
        }
        dispatch(generalOpenToastSuccess('Horario guardado exitosamente'));
        dispatch(setSelectedSucursal(null));
      }
    }
  } catch (error: any) {
    dispatch(generalOpenToastError(error?.response?.data?.message || error?.TypeError || 'Ocurrió un error al guardar el horario.', error?.response?.data?.status))
  } finally {
    dispatch(generalShowLoader(false))
  }
}